import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

const QUERY_PATRON_PLS_STATUS_V2 = gql`
  query {
    statusV2 {
      plsPlayerStatus {
        plsPlayerId
        firstName
        middleName
        lastName
        title
        dateOfBirth
        gender
        addresses {
          addressType
          street
          postalCode
          city
          state
          country
          receiveMail
        }
        phones {
          phoneType
          countryCode
          phoneNumber
          receiveSMS
          receiveCalls
        }
        emails
        location
        rewardsJoinDate
        preferredLanguage
        accounts {
          created
          plsPlayerId
          plsAccountNumber
          playerCards {
            plsPlayerId
            plsAccountNumber
            cardNumber
            cardType
          }
        }
        rewardsTier
        ytdTierPoints
        ltdTierPoints
        pointsToUpgradeTier
        pointsToMaintainTier
        pointsBalance
        freePlay
        primeTokenCount
        pointsToEarnAdditionalPrimeToken
        loyaltyLastUpdate
        nextRewardTier
        lastUpdate
      }
    }
  }
`;

export default graphql(QUERY_PATRON_PLS_STATUS_V2, { name: 'statusPlsData' });
